import React, { useEffect, useState } from "react";
import Header from "../../layout/Header";
import Footer from "../../layout/Footer";
import { useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "../../i18n"; // important to import
function AIFactsDetails() {
    const { t } = useTranslation("BusinessFactsDetails");
    const location = useLocation();
    const navigate = useNavigate();

    const [facts, setFacts] = useState([]);
    const [currentIndex, setCurrentIndex] = useState(0);
    const [isDisabled, setIsDisabled] = useState(false);

    useEffect(() => {
        if (location.state && location.state.facts) {
            setFacts(location.state.facts);
        } else {
            navigate("/sign-in");
            return;
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleNext = () => {
        const latestIndex = currentIndex + 1;
        if (latestIndex === facts.length) {
            setIsDisabled(true);
            handleSubmit();
        } else {
            setCurrentIndex(latestIndex);
        }
    };

    const handleSubmit = async () => {
        navigate("/free-trail/what-did-you-learn", {
            state: {
                step: true,
                trailId: location?.state?.trailId,
                name: location?.state?.name,
                userData: location?.state?.userData,
            },
        });
    };

    return (
        <>
            <Header />
            <section className="py-5">
                <div className="container">
                    <div className="row facts_details_step">
                        <div className="col-md-6">
                            <img
                                src={facts[currentIndex]?.image}
                                className="w-100 h-100"
                                alt=""
                            />
                        </div>
                        <div className="col-md-6 mt-4 mt-md-0">
                            <div className="ps-xl-4">
                                <h6>{t("top10thingstoknow")} </h6>
                                <h3>
                                    {currentIndex + 1}.
                                    {facts[currentIndex]?.title}
                                </h3>
                                <p>{facts[currentIndex]?.description}</p>
                            </div>
                        </div>
                    </div>

                    <div className="d-flex justify-content-end pt-4 pb-md-5">
                        <button
                            className="btn-explore p-sm-15 d-flex justify-content-between align-items-center gap-3 rounded-2 mt-md-4"
                            onClick={handleNext}
                            disabled={isDisabled}
                        >
                            {facts.length - 1 === currentIndex
                                ? t("submit")
                                : t("next")}
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width={22}
                                height={14}
                                viewBox="0 0 22 14"
                                fill="none"
                                className="ms-5"
                            >
                                <path
                                    d="M1 6.99854H21L16 1"
                                    stroke="white"
                                    strokeWidth="1.5"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                                <path
                                    d="M21 6.99805L16 12.9995"
                                    stroke="white"
                                    strokeWidth="1.5"
                                    strokeLinecap="round"
                                />
                            </svg>
                        </button>
                    </div>
                </div>
            </section>
            <Footer />
        </>
    );
}

export default AIFactsDetails;
